export class Adapter {
}

const reactAdapter = (actionHandler) => {
  Adapter.actionHandler = actionHandler;
};

export default reactAdapter;
